module.exports = __webpack_public_path__ + "static/media/slip_logo.75f2fda9.png";